import { UseMutationOptions, useMutation } from "@tanstack/react-query";
import { FieldValues } from "react-hook-form";
import axiosAuth from "../axiosAuth";
import { TNC_API } from "./apiRoutes";

const mutateUpdateUserTncMutation = async ({
  data,
}: {
  data: FieldValues;
}) => {
  return await axiosAuth.post(
    `${TNC_API}`,
    data
  );
};

const useUpdateUserTncMutationMutation = (
  queryParams?: UseMutationOptions<
    any,
    Error,
    {
      data: FieldValues;
    },
    unknown
  >
) =>
  useMutation({
    mutationFn: mutateUpdateUserTncMutation,
    ...queryParams,
  });

export default useUpdateUserTncMutationMutation;
